import type { CityConfig } from "../city-template/types";

export const indianTrailConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Indian Trail",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "indian-trail",
  route: "/cities/indian-trail",
  title: "Emergency Passport Indian Trail, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Indian Trail, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Union County and southeast Charlotte. Get your passport fast with Fast Passport Center.",
  h1: "Emergency & Expedited Passport Services in Indian Trail, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Indian Trail and Union County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Indian%20Trail%20North%20Carolina%20suburban%20community%20landscape%20at%20golden%20hour%20with%20modern%20family%20homes%20and%20green%20neighborhoods%2C%20Union%20County%20suburban%20growth%20with%20tree-lined%20streets%20and%20parks%2C%20warm%20sunset%20light%20over%20southeast%20Charlotte%20metro%20area%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20suburban%20photography%20with%20warm%20earthy%20tones%20and%20family-friendly%20community%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=indian-trail-hero-nc-001&orientation=landscape",
  heroImageAlt: "Indian Trail North Carolina suburban community with green neighborhoods and warm sunset light",
  geoPosition: "35.0768;-80.6692",
  geoPlacename: "Indian Trail, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 245 miles from Indian Trail via I-85",
  },
  nearbyCitiesZips: [
    { name: "Indian Trail", zips: "28079" },
    { name: "Matthews", zips: "28104, 28105" },
    { name: "Mint Hill", zips: "28227" },
    { name: "Stallings", zips: "28104" },
    { name: "Monroe", zips: "28110, 28111, 28112" },
    { name: "Wesley Chapel", zips: "28104" },
    { name: "Waxhaw", zips: "28173" },
    { name: "Weddington", zips: "28104" },
    { name: "Pineville", zips: "28134" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Cornelius", zips: "28031" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Gastonia", zips: "28052, 28054, 28056" },
    { name: "Harrisburg", zips: "28075" },
    { name: "Fort Mill, SC", zips: "29707, 29708, 29715, 29716" },
    { name: "Rock Hill, SC", zips: "29730, 29731, 29732, 29733" },
    { name: "Lancaster, SC", zips: "29720, 29721, 29722" },
    { name: "Wingate", zips: "28174" },
    { name: "Marshville", zips: "28103" },
    { name: "Unionville", zips: "28110" },
    { name: "Mineral Springs", zips: "28108" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Union County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Union County Hub", desc: "Serving Indian Trail, Matthews, Monroe, and the southeast Charlotte corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Matthews, NC", route: "/cities/matthews" },
    { name: "Emergency passport help in Concord, NC", route: "/cities/concord-nc" },
    { name: "Urgent passport services in Kannapolis, NC", route: "/cities/kannapolis" },
    { name: "Same-day passport help in Huntersville, NC", route: "/cities/huntersville" },
    { name: "Passport courier services in Gastonia, NC", route: "/cities/gastonia" },
    { name: "Passport courier services in Mooresville, NC", route: "/cities/mooresville" },
    { name: "Passport courier services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Passport courier services in Cornelius, NC", route: "/cities/cornelius" },
    { name: "Passport courier services in Davidson, NC", route: "/cities/davidson" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Indian Trail remotely via secure courier. We do not have a walk-in office in Indian Trail — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Union County and the southeast Charlotte area travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Union County and the southeast Charlotte metropolitan region",
  serviceAreaIntro: "From the growing suburban neighborhoods of Indian Trail to the charming streets of Matthews, from the quiet communities of Stallings and Wesley Chapel to the bustling town of Monroe, from the upscale areas of Waxhaw and Weddington to the vibrant corridors of southeast Charlotte, from the South Carolina border communities of Fort Mill and Rock Hill to the Piedmont towns of Wingate and Marshville — Fast Passport Center serves the entire Indian Trail region. We regularly help travelers from Union County, Mecklenburg County, and the southeast Charlotte area get their expedited passports fast.",
  nearbyCitiesIntro: "We serve all Indian Trail neighborhoods and the surrounding Union County and southeast Charlotte area including Matthews, Mint Hill, Stallings, Monroe, Wesley Chapel, Waxhaw, Weddington, Pineville, Charlotte, Huntersville, Cornelius, Davidson, Concord, Kannapolis, Gastonia, Harrisburg, Fort Mill, Rock Hill, Lancaster, Wingate, Marshville, Unionville, and Mineral Springs. If you are anywhere in Union County, Mecklenburg County, or the southeast Charlotte metropolitan area, we have you covered for fast passport and expedited passport services.",
  howItWorksIntro: "Most Indian Trail travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Indian Trail travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays in getting an expedited passport.",
  testimonialsIntro: "Indian Trail and Union County travelers trust us when their departure is days away. Here is what some of them have to say about our emergency passport and fast passport services.",
  faqIntro: "Have questions about expedited passports in Indian Trail? Here are the most common ones we hear from Union County and southeast Charlotte travelers about emergency passport and fast passport processing.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Indian Trail international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Ashley M.",
      location: "Indian Trail, NC",
      rating: 5,
      text: "My passport expired 3 days before our family trip to the Bahamas. Fast Passport Center had my renewal ready in 28 hours. I never left Indian Trail. The expedited passport service was outstanding.",
      service: "Passport Renewal",
    },
    {
      name: "Chris D.",
      location: "Matthews, NC",
      rating: 5,
      text: "Emergency passport for a business trip to London. Got it in 25 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Their fast passport service is incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer L.",
      location: "Waxhaw, NC",
      rating: 5,
      text: "First passport for my 9-year-old before our Europe trip. Fast Passport Center walked us through every step and had her passport in 4 days. So easy for Union County families.",
      service: "Child Passport",
    },
    {
      name: "Mark S.",
      location: "Monroe, NC",
      rating: 5,
      text: "Lost my passport 2 days before a cruise to the Caribbean. Fast Passport Center had a replacement in my hands in 31 hours. Their expedited passport service across Union County is unmatched.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "indian-trail-1",
      name: "Indian Trail Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6401 Indian Trail Fairview Rd",
      city: "Indian Trail",
      state: "NC",
      zip: "28079",
      phone: "(704) 821-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Indian Trail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Indian Trail facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "indian-trail-2",
      name: "Matthews Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W John St",
      city: "Matthews",
      state: "NC",
      zip: "28105",
      phone: "(704) 847-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Indian Trail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Matthews and eastern Mecklenburg County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "indian-trail-3",
      name: "Mint Hill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7815 Matthews Mint Hill Rd",
      city: "Mint Hill",
      state: "NC",
      zip: "28227",
      phone: "(704) 545-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles northwest of Indian Trail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mint Hill and eastern Mecklenburg County. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "indian-trail-4",
      name: "Monroe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1201 W Roosevelt Blvd",
      city: "Monroe",
      state: "NC",
      zip: "28110",
      phone: "(704) 289-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles southeast of Indian Trail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Union County and Monroe area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "indian-trail-5",
      name: "Union County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "400 N Main St",
      city: "Monroe",
      state: "NC",
      zip: "28110",
      phone: "(704) 282-2000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "10 miles southeast of Indian Trail, Courthouse",
      website: "https://www.unioncountync.gov/",
      websiteLabel: "Union County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "indian-trail-6",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Indian Trail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Indian Trail photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Union County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Indian Trail applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Union County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Indian Trail travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Indian Trail." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Indian Trail address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Indian Trail before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Indian Trail for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I get an expedited passport in Indian Trail?", a: "Fast Passport Center offers expedited passport services in Indian Trail in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day standard expedited option provides the best value. Both options include full document review and a dedicated agent to ensure your fast passport is processed correctly." },
    { q: "What is the closest passport agency to Indian Trail?", a: "The nearest regional passport agency to Indian Trail is the Atlanta Passport Agency, approximately 245 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Indian Trail without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Indian Trail?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Indian Trail — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Union County and southeast Charlotte residents." },
    { q: "Do you serve the entire Union County area for expedited passports?", a: "Absolutely. Fast Passport Center provides expedited passport services throughout the entire Union County and southeast Charlotte area including Indian Trail, Matthews, Mint Hill, Stallings, Monroe, Wesley Chapel, Waxhaw, Weddington, Pineville, Charlotte, Huntersville, Cornelius, Davidson, Concord, Kannapolis, Gastonia, Harrisburg, Fort Mill, Rock Hill, Lancaster, Wingate, Marshville, Unionville, and Mineral Springs. Our courier service works seamlessly from any address in Union County, Mecklenburg County, and surrounding areas." },
    { q: "Can I expedite a child passport in Indian Trail?", a: "Yes. Fast Passport Center expedites child passports in Indian Trail for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Union County families through the entire fast passport process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Indian Trail with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency for an expedited passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change. This is how we deliver fast passport and expedited passport services to Indian Trail without the long drive." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Indian Trail", address: "5800 Indian Trail Fairview Rd, Indian Trail, NC 28079", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Indian Trail", address: "6500 Indian Trail Fairview Rd, Indian Trail, NC 28079", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "Walmart Supercenter — Indian Trail", address: "2101 W Highway 74, Indian Trail, NC 28079", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "CVS Pharmacy — Matthews", address: "1409 Matthews Township Pkwy, Matthews, NC 28105", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Waxhaw", address: "1309 Waxhaw Pkwy, Waxhaw, NC 28173", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Monroe", address: "1409 W Roosevelt Blvd, Monroe, NC 28110", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Charlotte", address: "10310 E Independence Blvd, Charlotte, NC 28227", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html", websiteLabel: "FedEx Office" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Monroe",
      address: "1821 Windsor Square Dr, Monroe, NC 28110",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte East",
      address: "8501 East Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Matthews",
      address: "1510 N Independence Blvd, Matthews, NC 28105",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Matthews and eastern Mecklenburg area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Charlotte South",
      address: "201 W Arrowood Rd, Charlotte, NC 28217",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Charlotte metro and south Mecklenburg area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "20 miles west of Indian Trail",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. Only 30 minutes from Indian Trail.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "85 miles northeast of Indian Trail",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "170 miles east of Indian Trail",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Union County Register of Deeds',
      description: 'Marriage licenses and records for Union County. Apply in person or request certified copies.',
      url: 'https://www.unioncountync.gov/departments/register-of-deeds',
    },
    {
      label: 'Union County Clerk of Superior Court',
      description: 'Divorce records and decrees for Union County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/union-county/union-county-clerk-of-superior-court',
    },
  ],
};